<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { addEventClick } from "@/utils/themeImg";
//回退使用本版本
// import rtcClient from "web-263-finesdk";
import rtcClient from "@263sdk/web-finesdk";
//本地调试使用
// import rtcClient from "@/rtcClient.js";
import { getParameter, uuid } from "@/utils/global";
import { meetInfo } from "@/mixins/meet";
import { userLogin, heartbeat, userRefresh, getDisposableLogin, hostSetting, otherSetting } from "@/api/liveRequest/login";
import { getLiveInfo } from "@/api/liveRequest/liveInfo";
import { gethRoomControlFunc, getRoomMessageFunc } from "@/utils/socketMessageDispose";
import Bus from "@/components/doc/bus";
import { getUserRole } from "@/api/liveRequest/userApi";
export default {
  name: "App",
  data() {
    return {
      useGetUserRoleNum: 0,
      timer: null,
      rtcClients: new rtcClient(),
      roomId: getParameter("roomId"),
      code: getParameter("code"),
      liveId: getParameter("liveId"),
      errorCount: 0,
      loginStyle: getParameter("loginStyle"),
      appId: "cloud_webcast", //"cv_live" or "cloud_webcast
      data: [400, 400, 400, 400, 200],
      time: 0,
      tk: null,
      isLeave: false,
      preReqTime: null,
      liveType: 12, //默认主播
      guestId: getParameter("guestId"),
      disposableToken: getParameter("disposableToken"),
      redireUrl: getParameter("redireUrl"),
      loginToken: sessionStorage.getItem("disposableToken"),
    };
  },
  watch: {
    async liveStartStatus(n, o) {
      console.log(n, o);
      if (n === 2) {
        // if (this.liveStartTime == -1) {
        //   let liveStartTime = new Date().getTime() / 1000;
        //   this.$store.commit("SET_LIVESTARTTIME", liveStartTime);
        // }
      } else if (o == 2 && n != 2) {
        await this.leaveLive();
        this.clearUpload();
        this.$nextTick(() => {
          this.$store.commit("SET_ISLEAVE", this.isLeave);
          this.$router.push({
            name: "End",
            query: {
              t: this.getLiveTime(),
              g: this.praiseCount,
              d: this.rewardCount,
              loginStyle: "v2",
              liveId: this.liveId,
            },
          });
        });
      }
    },
    isChangeArea() {
      this.updateDocPosition();
    },
    hostSkin: {
      immediate: true,
      handler(val) {
        this.setTheme(val);
      },
    },
  },

  computed: {
    sid() {
      return this.$store.getters.sid;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    },
    rewardCount() {
      return this.$store.getters.rewardCount;
    },
    praiseCount() {
      return this.$store.getters.praiseCount;
    },
    liveStartTime() {
      return this.$store.getters.liveStartTime;
    },
    uid() {
      return this.userInfo?.uid;
    },
    scope() {
      return `cloud_webcast_localFiles_${this.liveId}_${this.uid}`;
    },
    chatRoomId() {
      return this.$store.getters.chatRoomId;
    },
    logInfo() {
      return this.$store.getters.logInfo;
    },
    isChangeArea() {
      return this.$store.getters.isChangeArea;
    },
    hostSkin() {
      return this.$store.getters.hostSkin;
    },
  },
  async created() {
    addEventClick();
    // window.document.documentElement.setAttribute("data-theme", 'Orange');
    this.$store.commit("SET_RTCCLIENT", this.rtcClients);
    const LoginInfo = sessionStorage.getItem("LoginInfo");
    console.log(JSON.parse(LoginInfo), "LoginInfo");
    this.addBusEvent();
    const loginInfo = JSON.parse(LoginInfo);
    if (loginInfo && this.roomId && this.loginStyle == "v2" && !this.disposableToken) {
      //TODO 如果是有 loginInfo 并且不是一次性鉴权走刷新登录逻辑
      this.login(loginInfo, true);
    } else if (this.disposableToken) {
      //TODO 如果是一次性鉴权走一次性登录逻辑
      this.getContract();
      this.getLive();
      console.log(this.disposableToken, "this.disposableToken");
      console.log(this.loginToken, "this.loginToken");

      if (this.loginToken && this.disposableToken == this.loginToken) {
        // console.log('刷新页面用');
        this.login(loginInfo, true);
      } else {
        const res = await getDisposableLogin(this.disposableToken);
        if (res.code == 200) {
          let LoginInfo = {
            nickName: res.data.nickName,
            passCode: res.data.password,
            user: res.data.userId,
            type: res.data.type,
          };
          this.login(LoginInfo, false);
          //TODO 一次性鉴权登录成功后记录此 disposableToken，刷新时使用
          sessionStorage.setItem("disposableToken", this.disposableToken);
          // sessionStorage.setItem("LoginInfo",JSON.stringify(LoginInfo))
        } else if (res.code === 6052 && this.redireUrl) {
          location.href = this.redireUrl;
        } else if (JSON.parse(LoginInfo) && this.roomId) {
          this.login(JSON.parse(LoginInfo), true);
        } else {
          this.$router.push({
            name: "Err",
            query: {
              m: res.msg,
            },
          });
          //this.login(JSON.parse(LoginInfo), true);
        }
      }
    } else {
      if (this.loginStyle == "v2") {
        // this.getLive();
      } else {
        this.login({ nickName: "dyy1234", passCode: "333333" }, true);
        this.appId = "cv_live";
      }
      if (this.loginStyle == "v2") {
        this.appId = "cloud_webcast";
      }
    }
    window.addEventListener("popstate", async () => {
      await this.leaveLive();
    });
    window.onpagehide = async () => {
      await this.leaveLive();
    };
    window.addEventListener("beforeunload", async () => {
      if (window.name == "isReload") {
        await this.leaveLive();
      }
    });
    console.log(this.$route, "this.$route");
    window.onbeforeunload = this.onbeforeunload;
  },
  mounted() {
    window.addEventListener("resize", this.updateDocPosition);
    document.addEventListener("scroll", this.updateDocPosition);
    this.init();
  },
  mixins: [meetInfo],
  methods: {
    setTheme(theme) {
      if (theme == "0") {
        window.document.documentElement.setAttribute("data-theme", "Blue");
      } else if (theme == "1") {
        window.document.documentElement.setAttribute("data-theme", "Orange");
      }
      Bus.$emit("changeTheme");
    },
    async init() {
      const { data } = await hostSetting(this.liveId, this.liveToken);
      console.log(data, "hostSetting");
      this.$store.commit("SET_ISCHANGEAREA", data.hostDefaultLayout);
      this.$store.commit("SET_SET_LOGO", data.loginPageLogo);
      this.$store.commit("SET_SET_BACKGROUND", data.loginPageBackground);
    },
    updateDocPosition() {
      const right = document.querySelector("html").scrollWidth - window.innerWidth - document.querySelector("html").scrollLeft;
      this.$store.commit("docInfo/SET_DOC_RIGHT", right - 10);
    },
    getLiveTime() {
      const seconds = (new Date().getTime() - this.liveStartTime * 1000) / 1000;
      var day = parseInt(seconds / (24 * 3600));

      var hour = parseInt((seconds - day * 24 * 3600) / 3600);
      var minutes = parseInt((seconds - day * 24 * 3600 - hour * 3600) / 60);
      var second = parseInt(seconds % 60);
      hour = hour < 10 ? `0${hour}` : hour;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      second = second < 10 ? `0${second}` : second;
      return hour + ":" + minutes + ":" + second;
    },
    onbeforeunload(event) {
      if (!this.$router.customForceReloadRouterName && this.$route.name !== "first" && this.$route.name !== "Login") {
        event.preventDefault();
        event.returnValue = "";
      }
    },
    removeUrl() {
      // 获取当前页面的 URL
      const currentUrl = window.location.href;

      // 解析 URL
      const url = new URL(currentUrl);

      // 检查是否包含 disposableToken 参数
      if (url.searchParams.has("disposableToken")) {
        // 移除 disposableToken 参数
        url.searchParams.delete("disposableToken");

        // 生成新的 URL，不包含 disposableToken
        const newUrl = url.toString();

        // 重定向到新的 URL
        window.location.href = newUrl;
      }
    },
    async leaveLive() {
      console.log(window);
      Bus.$emit("closeShare");
      this.errorCount = 0;
      if (this.tk) {
        console.log("清除heartbeat");
        this.clearWorker();
      }
      Bus.$emit("stopSubLive");
      //TODO 退出会议删除disposableToken 不能如此加
      //sessionStorage.removeItem('disposableToken')
      //this.clearLocalMedia();
      await this.rtcClients.RTCRoom.leaveRoom();
    },
    /**
     * 清除本地摄像头
     */
    clearLocalMedia() {
      navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then((mediaStream) => {
        // 1S后停止所有摄像头
        setTimeout(() => {
          const tracks = mediaStream.getTracks();
          tracks.forEach(function (track) {
            console.log(track, "track");
            track.stop();
          });
          console.log(tracks, "关闭所有tracks");
        }, 100);
      });
    },
    clearUpload() {
      sessionStorage.removeItem(this.scope + "_0");
      sessionStorage.removeItem(this.scope + "_1");
    },

    useGetUserRole () {
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (this.useGetUserRoleNum > 1) {
          console.log('this.useGetUserRoleNum', this.useGetUserRoleNum)
          this.useGetUserRoleNum = 0
          this.timer && clearTimeout(this.timer)
          return
        }
        this.useGetUserRoleNum++
        getUserRole(this.rtcClient.RTMSession.userInfo.uid, this.$store.getters.liveToken).then((res) => {
          let selfParticipant = this.$store.getters.selfParticipant;
          if (res.data.userId == this.$store.getters.selfParticipant.uid && res.data.role == 6) {
            selfParticipant.type = 3;
          }
          this.$store.commit("SET_SELFPARTICIPANT", selfParticipant);
          this.useGetUserRole()
          console.log(res, "获取角色信息", this.useGetUserRoleNum);
        });
      }, 2000)
    },
    addBusEvent() {
      Bus.$on("ConnectedCC", () => {
        console.log("cc重连");
        console.log(this.chatRoomId, "chatRoomId");
        // this.rtcClient.RTMSession.CcWebSocket.applyJoinGroup({
        //   gid: this.groupInfo.gid,
        //   cid: this.groupInfo.cid,
        //   proposer: {
        //     uid: this.rtcClient.RTMSession.userInfo.uid,
        //     cid: this.rtcClient.RTMSession.userInfo.cid
        //   }
        // });
        this.rtcClients.RTMSession.CcWebSocket.joinCvMcRoom(
          {
            room_id: this.chatRoomId,
            msg: this.$t("App.请求进入房间"),
          },
          this.appId,
        );
        this.logger.info({ code: 2080, message: { msg: "发送请求进入房间" } });
      });
      Bus.$on("participantChange", () => {
        this.useGetUserRoleNum = 0
        this.useGetUserRole()
      });
      Bus.$on("getLive", () => {
        this.getLive();
      });
      Bus.$on("login", async (info) => {
        await this.login(info);
      });
      Bus.$on("exitRoom", (info) => {
        this.exitLive(info);
      });
      Bus.$on("liveStatusChange", (info) => {
        console.log(info);
        if (this.isLeave) return;
        if (info.meetStatus == "end") {
          this.isLeave = true;
          this.$store.commit("SET_ISLEAVE", this.isLeave);
          this.clearUpload();
          this.leaveLive();
          this.$router.push({
            name: "End",
            query: {
              t: this.getLiveTime(),
              g: this.praiseCount,
              d: this.rewardCount,
              loginStyle: "v2",
              liveId: this.liveId,
            },
          });
        }
        if (info.meetStatus == "leave") {
          console.log(this.liveType, "info.msg.origin");
          let tips = info && info.msg && info.msg.origin && info.msg.origin == `${this.userInfo.cid}.${this.userInfo.uid}` ? (this.liveType === 12 ? this.$t("App.有新主播进入，您已被请出") : this.$t("App.该嘉宾已在其他地方登录")) : this.$t("App.直播服务连接已断开");
          this.exitLive(tips);
          // this.$router.push({
          //   name: "Login",
          //   query: {
          //     liveId: this.liveId,
          //     loginStyle: "v2",
          //   },
          // });

          // window.sessionStorage.setItem('customForceReloadRouterName', 'Login');
          // this.$router.customForceReloadRouterName = 'Login';
          // const routePath = this.$router.resolve({
          //   name: "Login",
          //   query: { liveId: this.liveId, loginStyle: "v2" },
          // }).href;
          // window.location.href = `${window.location.protocol}//${window.location.host}${routePath}`;
        }
        this.logger.info({ code: 2066, message: { msg: "离开直播间", data: info } });
      });
    },
    async getContract() {
      const data = await this.$store.dispatch("GET_CONTRACT");
      if (!data) return false;
      if (data.live_contract_status !== 1) {
        Message({
          message: this.$t("login.服务已停用"),
          type: "error",
          duration: 0,
        });
        return false;
      }
      sessionStorage.setItem("is_rts", data.is_rts);
      sessionStorage.setItem("live_resolution", data.live_resolution);
      return true;
    },
    async getLive() {
      const res = await getLiveInfo(this.liveId);
      if (res && res.code == 200) {
        console.log(res, "获取直播间信息");
        this.$store.commit("SET_LIVETITLE", res.data.title);
        if (res.data.endTime != -1 && res.data.currentTime > res.data.endTime) {
          Bus.$emit("loginerror", { info: this.$t("App.该直播已过期"), code: 3000 });
          return;
        }
        this.roomId = res.data.meetingId;
        this.$store.commit("SET_CONF_ID", res.data.confId);
        this.$store.commit("SET_LIVECONFIG", res.data.broadcastSettingInfo);
        this.$store.commit("SET_DEFAULT_SOURCE", res.data.broadcastSettingInfo.defalut_streaming_source);
        this.$store.commit("SET_LIVEROOMTYPE", res.data.liveRoomType);
        this.$store.commit("SET_CHAT_IMAGE", res.data.chatImages);
        this.$store.commit("SET_ROOMID", this.roomId);
        this.$store.commit("SET_DEFAULT_LIVE_CID", res.data.cid);
        this.$store.commit("SET_USET_TIME", res.data.hostUsersDuration);
        console.log(res.data.qaEnabled, "qaEnabled");
        this.$store.commit("SET_MIC_DEFAULT", res.data.guestMicDefault);
        this.$store.commit("SET_QA_ENABLED", res.data.qaEnabled);
        this.$store.commit("SET_VIDEO_WALL", res.data.videoWall);
        this.$store.commit("SET_HOST_SKIN", res.data.hostSkin);
      } else {
        Bus.$emit("loginerror", { info: res.msg, code: res.code });
      }
    },
    async login(LoginInfo, isRefresh) {
      this.isLeave = false;
      this.$store.commit("SET_ISLEAVE", this.isLeave);
      this.$store.commit("SET_LIVEID", this.liveId);
      let passCode = LoginInfo.type === 13 ? LoginInfo.guestPassword : LoginInfo.passCode;
      let user = !isRefresh ? `${uuid(15, 62)}${new Date().getTime()}` : LoginInfo.user; //非指定嘉宾随机取
      if (LoginInfo.type == 12) {
        //主播
        // user = `${this.liveId}${LoginInfo.passCode}`;
      }
      this.liveType = LoginInfo.type;
      // 指定嘉宾user为接口返回userId
      if (LoginInfo.type == 13) {
        user = LoginInfo.user;
      }
      if (this.disposableToken) {
        user = LoginInfo.user;
      }
      if (isRefresh) {
        await this.getLive();
      }
      // let user = "S62iWUNFjnAPOBO1639123980765";
      //joinRoom换取cid
      //TODO joinRoom后再pub，sub
      this.joinRoom(this.roomId, LoginInfo.nickName, isRefresh ? "" : passCode, user).then(async (res) => {
        // console.log(res,"joinRoom");
        if (res && res.cid) {
          if (res.loginCCRes.info && !JSON.parse(res.loginCCRes.info).passcodeOk) {
            Bus.$emit("loginerror", { info: this.$t("App.密码错误"), code: 2000 });
            this.leaveLive();
            return;
          } else {
            // let role = JSON.parse(res.loginCCRes.info).passcodeType;
            let proposeType = res.loginCCRes.proposer.type;
            let type = 10;
            if (proposeType == 3) {
              type = 12;
            } else if (proposeType == 1) {
              type = 11;
              if (LoginInfo.type == 13) {
                type = 13;
              }
            } else {
              Bus.$emit("loginerror", { info: this.$t("App.密码错误"), code: 2000 });
              this.leaveLive();
              return;
            }
            this.$store.commit(
              "SET_LOGINFO",
              Object.assign(this.logInfo, {
                roomId: this.roomId,
                userId: this.userInfo.uid,
                userName: LoginInfo.nickName,
              }),
            );
            // console.log(`%c ${JSON.stringify(this.logInfo)}`,'color:red;font-size:18px')
            if (this.rtcClients.RTMSession.CcWebSocket) {
              this.$store.commit("SET_CCWEBSOCKETCLIENT", this.rtcClients.RTMSession.CcWebSocket);
              if (isRefresh) {
                await this.refreshLogin(LoginInfo, type, user);
              } else {
                await this.loginLive(LoginInfo, type, user);
                console.log(1);
              }
            }
            this.$store.commit("SET_GROUPINFO", {
              gid: res.groupId,
              cid: res.cid,
            });
          }
        } else {
          this.loginLive(LoginInfo, 12, user);
        }
        console.log(this.rtcClients.RTMSession.CcWebSocket, "CcWebSocket");
      });
    },
    async loginLive(LoginInfo, type, user) {
      let submitLoginInfo = {
        nickName: LoginInfo.nickName,
        passCode: LoginInfo.passCode,
        sid: this.sid,
        type,
        webcastId: this.liveId,
        specialGuestId: getParameter("guestId"),
      };
      if (this.disposableToken) {
        submitLoginInfo = Object.assign(submitLoginInfo, {
          disposableToken: this.disposableToken,
        });
      }
      userLogin(submitLoginInfo).then(async (res) => {
        console.log(res, "userLogin");
        setTimeout(() => {
          this.$store.commit("SET_FIRSTINIT", false);
        }, 2000);
        if (res && res.code != 200 && this.disposableToken) {
          const msg = res.code == 6052 ? this.$t("App.直播间不存在") : res.msg;
          this.$router.push({
            name: "Err",
            query: {
              m: msg,
            },
          });
          return;
        }
        if (res && res.code == 200) {
          this.setLogin(LoginInfo, res, type, user);
        } else if (res.code == 6000) {
          this.LoginErr(res);
          this.$alert(this.$t("App.当前并发已满，请尽快与服务人员联系"), {
            title: this.$t("App.提示"),
            confirmButtonText: this.$t("App.我知道了"),
          });
        } else if (res && res.code == 6007) {
          res.msg = null;
          this.LoginErr(res);
          this.$alert(this.$t("App.合同已失效，请联系您的专属客服"), {
            title: this.$t("App.提示"),
            confirmButtonText: this.$t("App.我知道了"),
          });
        } else if (res && res.code == 6043) {
          this.LoginErr(res);
          this.$alert(res.msg, {
            title: this.$t("App.提示"),
            confirmButtonText: this.$t("App.我知道了"),
          });
        } else {
          this.LoginErr(res);
        }
      });
    },
    async refreshLogin(LoginInfo, type, user) {
      userRefresh(
        {
          sid: this.sid,
          webcastId: this.liveId,
          token: LoginInfo.token,
        },
        LoginInfo.token,
      ).then((res) => {
        setTimeout(() => {
          this.$store.commit("SET_FIRSTINIT", false);
        }, 2000);
        if (res && res.code != 200 && this.disposableToken) {
          this.$router.push({
            name: "Err",
            query: {
              m: res.msg,
            },
          });
          return;
        }
        if (res && res.code == 200) {
          res.data.token = LoginInfo.token;
          this.setLogin(LoginInfo, res, type, user);
        } else {
          this.LoginErr(res);
        }
      });
    },
    async setLogin(LoginInfo, res, type, user) {
      // if (this.loginStyle == "v1") {
      //   await this.rtcClients.RTMSession.CcWebSocket.customizeSendMsg(
      //     {
      //       cmd: 103,
      //       id: `${uuid(15, 62)}${new Date().getTime()}`,
      //     },
      //     { app_id: this.appId }
      //   );
      // }
      this.logger.init({
        cid: res?.data?.webcastCid || "",
        uid: user || "",
        webcastId: getParameter("liveId") || "",
        userName: LoginInfo.nickName,
      });

      console.log(LoginInfo, "LoginInfo........");
      sessionStorage.setItem(
        "LoginInfo",
        JSON.stringify({
          nickName: LoginInfo.nickName,
          passCode: LoginInfo.passCode,
          guestPassword: LoginInfo.guestPassword,
          token: res.data.token,
          user: user,
          type: LoginInfo.type,
          specialGuestId: getParameter("guestId"),
        }),
      );
      // await userInfo(this.liveId, res.data.token)
      sessionStorage.setItem("chatRoomId", res.data.chatRoomId);

      this.$store.commit("SET_CHATROOMID", res.data.chatRoomId);

      this.$store.commit("SET_LIVETOKEN", res.data.token);
      this.$store.commit("SET_CONF_ID", res.data.confId);

      console.log("chatRoomId....", res.data.chatRoomId);

      this.rtcClients.RTMSession.CcWebSocket.joinCvMcRoom(
        {
          room_id: res.data.chatRoomId,
          msg: this.$t("App.请求进入房间"),
        },
        this.appId,
      );
      this.refreshToken(res.data.token);
      this.rtcClients.RTMSession.CcWebSocket.getCvMcRoomMessage = (msg) => {
        // console.log(msg, "roomMsg");
        getRoomMessageFunc(msg);
        switch (msg.cmd) {
          case 7125: {
            if (msg.requestData && msg.requestData.event && msg.requestData.event == "pushStream" && msg.requestData.pullStreamUrl && msg.requestData.pullStreamUrl.code == 200) {
              this.$store.commit("SET_PSEUDOLIVE", JSON.stringify(msg.requestData.pullStreamUrl.data));
            }
            break;
          }
        }
      };
      this.rtcClients.RTMSession.CcWebSocket.getCvMcRoomControl = (res) => {
        console.log("getCvMcRoomControl", res);
        switch (res.cmd) {
          case 6157: {
            this.$store.commit("SET_AUDIT", res);
            break;
          }
          case 6167: {
            this.$store.commit("SET_TOPHIGHLIGHT", res);
            break;
          }
        }
        gethRoomControlFunc(res);
      };
      // let _loginResult = res.data.loginResult;
      let _liveRoomStatus = res.data.liveRoomStatus;
      let _voipInfo = res.data.voipInfo;
      this.$store.commit("SET_PLAYERURL", res.data.player_url);
      this.$store.commit("SET_LIVEROOMSTATUS", _liveRoomStatus.liveStatus);
      this.$store.commit("SET_OPTYPE", _liveRoomStatus.opType);
      this.$store.commit("SET_USED", _liveRoomStatus.used);
      this.$store.commit("SET_STREAMSTATUS", _liveRoomStatus.pushStreamStatus);
      this.$store.commit("SET_USERROLE", res.data.role);
      this.$store.commit("SET_LIVETITLE", res.data.title);
      this.$store.commit("SET_LIVELOGO", res.data.logo);
      this.$store.commit("SET_RECORDSTATUS", _liveRoomStatus.recordStatus); //设置录制中的状态
      this.$store.commit("SET_AUTORECORDING", res.data.autoRecording);
      this.$store.commit("SET_PUSHSTREAMSTATUS", _liveRoomStatus.pushStreamStatus);
      this.$store.commit("SET_LIVESTARTTIME", res.data.confStartTime);
      const recordDuration = _liveRoomStatus.recordDuration != -1 ? _liveRoomStatus.recordDuration / 1000 : 0;
      // 录制开始时间计算：当前录制段开始时间 减去 原各个录制段总时长
      // this.$store.commit(
      //   "SET_RECORD_START_TIME",
      //   _liveRoomStatus.webcastStartTime != 0 && _liveRoomStatus.webcastStartTime != -1
      //     ? _liveRoomStatus.webcastStartTime / 1000 - recordDuration
      //     : recordDuration ? new Date().getTime() / 1000 - recordDuration : -1
      // );
      this.$store.commit("SET_RECORD_START_TIME", recordDuration ? new Date().getTime() / 1000 - recordDuration : -1);
      // this.$store.commit("SET_NICKNAME", res.data.nickName);
      // this.$store.commit("SET_LAYOUTtOKEN", _loginResult.data.token);
      this.$store.commit("SET_GUESTSEEAUTH", res.data.guestSeeAuth);
      this.$store.commit("SET_VIDEO_WALL", res.data.videoWall);
      this.$store.commit("SET_HOST_SKIN", res.data.hostSkin);
      this.$store.commit("SET_VOIPINFO", _voipInfo);
      this.$store.commit("SET_MEETSTATUS", res.data.meetStatus);
      this.$store.commit("SET_AUTHCHECKTOKEN", res.data.authCheckToken);
      if (typeof res.data.chatImages !== "undefined") {
        this.$store.commit("SET_CHAT_IMAGE", res.data.chatImages);
      }
      // 设置摄像头分辨率
      this.$store.commit("SET_CAMERA_RESOLUTION", res.data.cameraResolution);

      if (res.data.broadcastSettingInfo) {
        this.$store.commit("SET_LIVECONFIG", res.data.broadcastSettingInfo);
      }

      if (res.data.liveRoomType !== undefined) {
        this.$store.commit("SET_LIVEROOMTYPE", res.data.liveRoomType);
      }

      // if (this.$store.getters.selfParticipant) {
      //   this.$store.commit(
      //     "SET_SELFPARTICIPANT",
      //     Object.assign(this.$store.getters.selfParticipant, {
      //       type: type == 12 ? 3 : 1,
      //     })
      //   );
      // }
      Bus.$emit("loginSuccess", {
        liveId: this.liveId,
        roomId: this.roomId,
      });
      this.otherSetting(res.data.token);
    },
    async otherSetting(token) {
      const { code, data } = await otherSetting(this.liveId, null, token);
      if (code === 200) {
        // this.videoAudit = data.is_video_audit;
        console.log(data.is_video_audit, "data.is_video_audit");
        this.$store.commit("SET_AUDIO_AUDIT", data.is_video_audit);
      }
    },
    LoginErr(res) {
      const LoginInfo = sessionStorage.getItem("LoginInfo");
      if (JSON.parse(LoginInfo) && getParameter("roomId") && this.loginStyle == "v2") {
        this.$confirm(this.$t("App.服务器异常，进入直播间失败"), this.$t("App.提示"), {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t("App.确定"),
          cancelButtonText: this.$t("App.取消"),
        })
          .then(() => {
            this.leaveLive();
            // this.$router.push({
            //   name: "Login",
            //   query: { liveId: this.liveId, loginStyle: "v2" },
            // }).then(() => {
            //   window.location.reload();
            // });

            window.sessionStorage.setItem("customForceReloadRouterName", "Login");
            this.$router.customForceReloadRouterName = "Login";
            const routePath = this.$router.resolve({
              name: "Login",
              query: { liveId: this.liveId, loginStyle: "v2" },
            }).href;
            if (this.redireUrl) {
              location.href = this.redireUrl;
            } else {
              // TODO 如果是一次性鉴权地址，调到登录失败页，普通的跳到登录页
              if (this.disposableToken) {
                this.$router.push({
                  name: "Err",
                  query: {
                    m: this.$t("App.登录失败"),
                  },
                });
              } else {
                window.location.href = `${window.location.protocol}//${window.location.host}${routePath}`;
              }
            }
          })
          .catch(() => {
            this.leaveLive();
            // this.$router.push({
            //   name: "Login",
            //   query: { liveId: this.liveId, loginStyle: "v2" },
            // }).then(() => {
            //   window.location.reload();
            // });

            window.sessionStorage.setItem("customForceReloadRouterName", "Login");
            this.$router.customForceReloadRouterName = "Login";
            const routePath = this.$router.resolve({
              name: "Login",
              query: { liveId: this.liveId, loginStyle: "v2" },
            }).href;
            // TODO 如果是一次性鉴权地址，配置redireUrl调到redireUrl，未配置到登录失败页，普通的跳到登录页
            if (this.redireUrl) {
              location.href = this.redireUrl;
            } else {
              if (this.disposableToken) {
                this.$router.push({
                  name: "Err",
                  query: {
                    m: this.$t("App.登录失败"),
                  },
                });
              } else {
                window.location.href = `${window.location.protocol}//${window.location.host}${routePath}`;
              }
              //window.location.href = `${window.location.protocol}//${window.location.host}${routePath}`;
            }
          });
      } else {
        this.leaveLive();
        Bus.$emit("loginerror", { info: res.msg, code: res.code });
      }
    },
    refreshToken(token) {
      console.log(process.env.NODE_ENV, "env");
      let baseUrl = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "dev" || process.env.NODE_ENV === "test" ? "/cla/" : "/";
      this.tk = new Worker(`${baseUrl}webworker.js`);
      this.tk.postMessage({ status: "start" });
      this.tk.onmessage = (info) => {
        const { status } = info.data;
        if (status == 0) {
          this.heartbeatFunc(token);
          //Bus.$emit("timerloop");
        } else {
          Bus.$emit("startUserTimer");
        }
      };
    },
    clearWorker() {
      if (this.tk) {
        this.tk.postMessage({ status: "end" });
        this.tk.terminate();
      }
    },
    /*{{$t('App.刷新')}}token */
    heartbeatFunc(token) {
      heartbeat(token || this.liveToken)
        .then((res) => {
          this.errorCount = 0;
          this.preReqTime = null;
          if (res.code === 400 || res.code === 20001 || res.code === 6020) {
            // removeToken();
            this.clearWorker();
            this.exitLive();
          }
          //  Bus.$emit('loginerror',{info:res.msg})
        })
        .catch((err) => {
          if (!this.preReqTime) {
            this.preReqTime = Date.now();
          }
          this.errorCount++;
          if (this.errorCount >= 3 || (this.preReqTime && Date.now() - this.preReqTime > 25000)) {
            this.errorCount = 0;
            this.preReqTime = null;
            // removeToken();
            this.clearWorker();
            this.exitLive();
          }
          this.logger.info({ code: 2003, message: err });
        });
    },
    exitLive(tips) {
      this.leaveLive();
      if (!this.roomId) return;
      if (this.isLeave) return;
      this.isLeave = true;
      Bus.$emit("closeShare");
      this.$store.commit("SET_ISLEAVE", this.isLeave);

      const tipsInfo = tips || this.$t("App.您已离开直播");

      console.log(this.guestId, "this.guestId");

      this.$alert(tipsInfo, {
        title: this.$t("App.提示"),
        customClass: "tip-alert text-left",
        confirmButtonText: this.$t("App.我知道了"),
        callback: () => {
          this.leaveLive();
          // this.$store.commit("SET_ISCHECK", true);

          // this.$router.push({
          //   name: "Login",
          //   query: this.guestId
          //     ? {
          //       liveId: this.liveId,
          //       loginStyle: "v2",
          //       guestId: this.guestId,
          //     }
          //     : { liveId: this.liveId, loginStyle: "v2" },
          // }).then(() => {
          //   window.location.reload();
          // });

          window.sessionStorage.setItem("customForceReloadRouterName", "Login");
          this.$router.customForceReloadRouterName = "Login";
          const routePath = this.$router.resolve({
            name: "Login",
            query: this.guestId
              ? {
                  liveId: this.liveId,
                  loginStyle: "v2",
                  guestId: this.guestId,
                }
              : { liveId: this.liveId, loginStyle: "v2" },
          }).href;
          // TODO 如果是一次性鉴权地址，配置redireUrl调到redireUrl，未配置到登录失败页，普通的跳到登录页
          if (this.redireUrl) {
            location.href = this.redireUrl;
          } else {
            if (this.disposableToken) {
              this.$router.push({
                name: "Err",
                query: {
                  m: this.$t("App.登录失败"),
                },
              });
            } else {
              window.location.href = `${window.location.protocol}//${window.location.host}${routePath}`;
            }
          }
          // if(this.redireUrl){
          //     location.href = this.redireUrl;
          //   } else {

          //     window.location.href = `${window.location.protocol}//${window.location.host}${routePath}`;
          //   }
        },
      });
    },
  },
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
  width: 100%;
  background: #131625;
  overflow: hidden;
}

body {
  margin: 0px;
}

#app {
  font-family: PingFangSC-Regular, PingFang SC, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: auto; /**整屏添加滚动条，适应自己放大页面的情况 */
}
/**自定义滚动条样式 */
.scrollbar::-webkit-scrollbar-thumb {
  width: 5px;
  margin: auto;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #c2c2c2;
  border-radius: 10px;
}

.scrollbar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  width: 4px;
  background: transparent;
}
</style>
